import React from 'react';
import { Link } from 'react-scroll';

// style
import './style.scss';

export default function Home() {
  return (
    <div id="home">
      <div className="home-header">
        <h1 className="text-center">
          Hello , I am Tousif Ahmed <br />{' '}
          <span className="role">A Full-stack Web Developer</span>
        </h1>
      </div>
      <a
        href="https://drive.google.com/file/d/1M-RBB1D2TuWqPOCLrYhLO5XUl72YI8-f/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
      >
        <button className="cv-btn">View Resume</button>
      </a>
      <div className="go-down">
        <p>Learn more about me</p>
        <span>
          <Link to="about" smooth={true} duration={300} className="link">
            <i className="fas fa-caret-down fa-2x"></i>
          </Link>
        </span>
      </div>
    </div>
  );
}
